const sliderRangeUtils = (() => {
  const getSimpleRange = (min: number, max: number, step: number) => [
    { value: min, step },
    { value: max },
  ]

  const getProgressiveRange = (values: number[]) => {
    const range = values.map((value, index) => {
      if (values[index + 1]) {
        return { value, step: values[index + 1] - value }
      }

      return { value }
    })

    return range
  }

  return {
    getSimpleRange,
    getProgressiveRange,
  }
})()
export { sliderRangeUtils }
